import ClubOffers from './ClubOffers';

export default ClubOffers;
